import React from "react";
import { Box, Text } from "@chakra-ui/react";

type Props = {
  children: string;
};

export const TitleSidebar: React.FC<Props> = ({ children }) => {
  return (
    <Box pb="2">
      <Text mt="2" fontWeight="bold" fontSize="x-large">
        {children}
      </Text>
    </Box>
  );
};
